<script>
  import { Checkbox } from "carbon-components-svelte";
  import { Button, Select, SelectItem } from "paxray-components-svelte";
  import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";

  export let newfilterstep = "";
  export let processSteps = [];
  export let filterCreate = {
    name: "",
    type: "",
    steps: [],
    col: "",
    value: "",
    comparison: "eq",
  };

  $: if (!filterCreate.steps || filterCreate.steps.length === 0) {
    filterCreate.steps = [".*"];
    filterCreate = filterCreate;
  }
</script>

<div class="process-flow-filter">
  <div class="process-flow-controls">
    <div class="add-process-step">
      <label class="add-process-step-label" for="add-process-step"
        >Add process step</label
      >
      <Select id="add-process-step" hideLabel bind:selected={newfilterstep}>
        <SelectItem value="" text="" />
        <SelectItem value=".*" text="Any" />
        {#each Object.values(processSteps).sort() as processStep}
          <SelectItem value={processStep} text={processStep}></SelectItem>
        {/each}
      </Select>
    </div>
    <Checkbox bind:checked={filterCreate.invert} labelText="Invert filter"
    ></Checkbox>
  </div>
  <div class="process-flow-sequence">
    <span>Process Start</span>
    <img src="/img/assistant/icons/arrow_down_dark.svg" alt="" />
    {#each filterCreate.steps as step, index}
      <div class="step">
        <Select hideLabel bind:selected={step}>
          <SelectItem value=".*" text="Any" />
          {#each Object.values(processSteps).sort() as processStep}
            <SelectItem value={processStep} text={processStep}></SelectItem>
          {/each}
        </Select>
        {#if filterCreate.steps.length > 1}
          <Button
            size="field"
            kind="danger-tertiary"
            iconDescription="Delete"
            icon={TrashCan16}
            on:click={() => {
              filterCreate.steps.splice(index, 1);
              filterCreate = filterCreate;
            }}
          />
        {/if}
      </div>
    {/each}
    <img src="/img/assistant/icons/arrow_down_dark.svg" alt="" />
    <span>Process End</span>
  </div>
</div>

<style>
  .process-flow-filter {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .process-flow-sequence {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }

  .process-flow-controls {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .step {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .step :global(.bx--form-item) {
    flex: 1;
    min-width: 0;
  }

  .add-process-step {
    display: flex;
    flex-direction: column;
    gap: var(--xs);
  }

  .add-process-step-label {
    color: var(--pax-black);
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.02em;
    line-height: 1rem;
  }

  span {
    background-color: var(--pax-smoke);
    height: 3rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
  }

  img {
    align-self: center;
    height: 1rem;
  }
</style>
